import { Building2, Video, Shuffle } from "lucide-react";
import { Badge } from "./common/Badge";
import { Label } from "./common/Label";
import { cn } from "../utils/utils";
import { CONSULTATION_MODE } from "../lib/ScheduleUtils";
import { getLocalizedConsultationMode } from "../i18n/scheduleLabels";
import useBrandTranslation from "../hooks/useBrandTranslation";

const MODE_UI = {
  [CONSULTATION_MODE.IN_PERSON]: { variant: "consultationInPerson", Icon: Building2 },
  [CONSULTATION_MODE.VIRTUAL]: { variant: "consultationVirtual", Icon: Video },
  [CONSULTATION_MODE.BOTH]: { variant: "consultationBoth", Icon: Shuffle },
};

/** Chip con la modalidad (presencial / virtual / ambas). No renderiza nada si no hay modalidad. */
export function ConsultationModeBadge({ mode, className }) {
  const ui = MODE_UI[mode];
  if (!ui) return null;
  const { variant, Icon } = ui;
  return (
    <Badge variant={variant} className={cn("gap-1", className)}>
      <Icon className="w-3 h-3" />
      {getLocalizedConsultationMode(mode)}
    </Badge>
  );
}

/**
 * Selector Presencial / Virtual para reservar en un horario "ambas".
 * Si el horario tiene modalidad fija, solo la muestra.
 */
export function ConsultationModePicker({ slotMode, value, onChange }) {
  const { t } = useBrandTranslation();

  if (slotMode !== CONSULTATION_MODE.BOTH) {
    return (
      <div className="flex items-center gap-2">
        <Label>{t("schedule.consultationModeLabel", "Formato de consulta")}:</Label>
        <ConsultationModeBadge mode={slotMode || CONSULTATION_MODE.IN_PERSON} />
      </div>
    );
  }

  const options = [CONSULTATION_MODE.IN_PERSON, CONSULTATION_MODE.VIRTUAL];
  return (
    <div>
      <Label>{t("schedule.consultationModeChoose", "Modalidad del turno *")}</Label>
      <div className="grid grid-cols-2 gap-2 mt-2">
        {options.map((mode) => {
          const { Icon } = MODE_UI[mode];
          const selected = value === mode;
          return (
            <button
              key={mode}
              type="button"
              onClick={() => onChange(mode)}
              className={cn(
                "flex items-center justify-center gap-2 rounded-lg border px-3 py-2 text-sm font-medium transition-colors",
                selected
                  ? "border-blue-600 bg-blue-50 text-blue-900"
                  : "border-gray-200 bg-white text-gray-700 hover:bg-gray-50"
              )}
            >
              <Icon className="w-4 h-4" />
              {getLocalizedConsultationMode(mode)}
            </button>
          );
        })}
      </div>
    </div>
  );
}
